import { useRoadmapHistory } from '@/domain/roadmap/hooks';
import { type History } from '@/domain/roadmap/types';
import { toLocaleDateTimeString } from '@/utils/datetime';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';
import { DataGrid, type GridColDef } from '@andritzot/metris-web-ui/mui-x/data-grid';
import { useMemo } from 'react';

import { historyFields } from './historyFields';

type HistoryTableProps = {
  roadmapId: number;
  field?: string | null;
};

const baseColumns: GridColDef<History>[] = [
  {
    field: 'userName',
    headerName: 'User',
    flex: 1,
    valueGetter: (_value, row) => row.user?.name ?? '',
  },
  {
    field: 'timestamp',
    headerName: 'Date',
    flex: 1.2,
    valueGetter: (_value, row) => (row.timestamp ? toLocaleDateTimeString(row.timestamp) : ''),
  },
  { field: 'originalValue', headerName: 'Previous Value', flex: 1 },
  { field: 'newValue', headerName: 'New Value', flex: 1 },
];

const fieldColumn: GridColDef<History> = {
  field: 'field',
  headerName: 'Field',
  flex: 1,
  valueGetter: (_value, row) => historyFields[row.field] ?? row.field,
};

const HistoryTable = ({ roadmapId, field = null }: HistoryTableProps) => {
  const { data: history = [], isLoading } = useRoadmapHistory(roadmapId, field);

  const columns = useMemo<GridColDef<History>[]>(
    () => (field ? baseColumns : [baseColumns[0], baseColumns[1], fieldColumn, baseColumns[2], baseColumns[3]]),
    [field],
  );

  return (
    <Box sx={{ width: 620, height: 200 }}>
      <DataGrid
        rows={history}
        columns={columns}
        loading={isLoading}
        getRowId={(row) => row.idRoadmapHistory}
        density="compact"
        pageSizeOptions={[5, 10, 25]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

export default HistoryTable;
